import { Fragment } from "react";
import { Link } from "react-router-dom";

/** Renders copy containing [anchor](/path) links as text with internal Links. */
export function LinkedText({ text }: { text: string }) {
  const parts = text.split(/(\[[^\]]+\]\([^)]+\))/g);
  return (
    <>
      {parts.map((part, i) => {
        const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (!m) return <Fragment key={i}>{part}</Fragment>;
        return (
          <Link key={i} to={m[2]} className="text-secondary underline underline-offset-4 hover:text-secondary/80">
            {m[1]}
          </Link>
        );
      })}
    </>
  );
}
